/** A trip's dispatch page gives each tab its own route, `/dispatch/trips/:id/<tab>` (`recordTabRoutes`). Which of them show depends on the trip and the user (`availableTripTabs`). */
export const DISPATCH_TRIP_TABS = ['overview', 'record', 'cash', 'timeline'] as const;
export type DispatchTripTab = (typeof DISPATCH_TRIP_TABS)[number];

export const DISPATCH_TRIP_TAB_LABELS: Record<DispatchTripTab, string> = {
  overview: 'Overview',
  record: 'Record for driver',
  cash: 'Cash',
  timeline: 'Timeline',
};

export const dispatchPaths = {
  assignTrip: (tripId: string) => `/dispatch/trips/${tripId}/assign`,
  /** The bare path redirects to the overview tab. */
  dispatchTrip: (tripId: string) => `/dispatch/trips/${tripId}`,
  dispatchTripTab: (tripId: string, tab: DispatchTripTab) => `/dispatch/trips/${tripId}/${tab}`,
  home: '/dispatch',
} as const;
